<script>
import {
  iButton,
  iButtonSizes,
  iButtonStyles,
  iButtonTypes,
  iMenu,
  iMenuItem,
  iMenuTriggerAlignOptions,
} from '@inscribe/signal';
import { mapGetters } from 'vuex';
import * as fileTypes from '@/constants/fileTypes';

export default {
  components: {
    iButton,
    iMenu,
    iMenuItem,
  },
  props: {
    document: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      iButtonSizes,
      iButtonStyles,
      iButtonTypes,
      iMenuTriggerAlignOptions,
      fileTypes,
    };
  },
  computed: {
    ...mapGetters({
      isParsedDetailHighlighterEnabled: 'parsedDetailHighlighterEnabled',
    }),
    currentRoute() {
      let label = '';
      let name = '';
      switch (this.$route.name) {
        case 'document-signals':
          label = 'Signals';
          name = 'document-signals';
          break;
        case 'document-text':
          label = 'Text';
          name = 'document-text';
          break;
        case 'document-highlighter':
          label = 'Fonts';
          name = 'document-highlighter';
          break;
        case 'document-parsed-details-highlighter':
          label = 'Parsed Details';
          name = 'document-parsed-details-highlighter';
          break;
      }

      return {
        label,
        name,
      };
    },
    isDocHighlighterEnabled() {
      return (
        this.document?.file_type !== fileTypes.IMAGE &&
        this.$store.state.featureFlagsStore.featureFlags[
          'detector-font-highlighter-tool'
        ]
      );
    },
  },
  methods: {
    showRoute(route) {
      this.$router
        .push({
          name: route,
          params: {
            customer_id: this.$route?.params?.customer_id,
            document_id: this.$route?.params?.document_id,
          },
        })
        .catch();
    },
  },
};
</script>

<template>
  <div class="document-view-selector">
    <i-menu
      :close-on-item-click="true"
      :trigger-align="iMenuTriggerAlignOptions.LEFT"
      data-testid="sort-by-filter-menu"
      :width="200"
    >
      <template #trigger>
        <i-button
          :size="iButtonSizes.SMALL"
          :button-style="iButtonStyles.OUTLINE"
          :type="iButtonTypes.NEUTRAL"
          right-icon="medium-chevron-expand"
          :label="currentRoute.label"
        ></i-button>
      </template>
      <template #items>
        <i-menu-item
          :checked="currentRoute.name === 'document-signals'"
          label="Signals"
          @item-click="showRoute('document-signals')"
        ></i-menu-item>
        <i-menu-item
          :checked="currentRoute.name === 'document-text'"
          label="Text"
          @item-click="showRoute('document-text')"
        ></i-menu-item>
        <i-menu-item
          v-if="isDocHighlighterEnabled"
          :checked="currentRoute.name === 'document-highlighter'"
          label="Fonts"
          @item-click="showRoute('document-highlighter')"
        ></i-menu-item>
        <i-menu-item
          v-if="isParsedDetailHighlighterEnabled"
          :checked="currentRoute.name === 'document-parsed-details-highlighter'"
          label="Parsed Details"
          @item-click="showRoute('document-parsed-details-highlighter')"
        ></i-menu-item>
      </template>
    </i-menu>
  </div>
</template>
